import React, { useState, useEffect } from 'react';
import AdminAuth from './AdminAuth';
import AdminDashboard from './AdminDashboard';
import { ContentProvider } from '../../contexts/ContentContext';
import apiClient from '../../services/apiClient';

const Admin = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user has a valid JWT token
    const checkAuthentication = async () => {
      const token = apiClient.getStoredToken();
      if (token && !apiClient.isTokenExpired()) {
        try {
          const verification = await apiClient.verifyToken();
          if (verification.valid) {
            console.log('✅ Valid JWT token found, user is authenticated');
            setIsAuthenticated(true);
          } else {
            console.log('❌ JWT token is invalid, clearing...');
            apiClient.setToken(null);
            setIsAuthenticated(false);
          }
        } catch (error) {
          console.log('❌ Token verification failed, clearing...');
          apiClient.setToken(null);
          setIsAuthenticated(false);
        }
      } else {
        console.log('📝 No valid JWT token found, user needs to login');
        setIsAuthenticated(false);
      }
      setIsLoading(false);
    };

    checkAuthentication();
  }, []);

  const handleAuthenticated = () => {
    console.log('🔐 User successfully authenticated with JWT token');
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    console.log('🚪 User logging out, clearing JWT token');
    apiClient.logout();
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8f9fa'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1rem',
          color: '#6c757d'
        }}>
          <i className="fas fa-spinner fa-spin" style={{ fontSize: '2rem' }}></i>
          <span>Loading Admin Panel...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <AdminAuth onAuthenticated={handleAuthenticated} />;
  }

  return (
    <ContentProvider>
      <AdminDashboard onLogout={handleLogout} />
    </ContentProvider>
  );
};

export default Admin;

